import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    count: 0,
    selectlayerid: 0,
    initstatus: [
      {
        value: '',
        label: '请选择状态',
      },
      {
        value: '启用',
        label: '启用',
      },
      {
        value: '禁用',
        label: '禁用',
      },
    ],
    countryinit: [
      {
        value: 'zh-cn',
        label: '中国',
      },
      {
        value: 'en',
        label: '英国',
      },
      {
        value: 'it',
        label: '意大利',
      },
      {
        value: 'es',
        label: '西班牙',
      },
      {
        value: 'pl',
        label: '波兰',
      },
      {
        value: 'nl',
        label: '荷兰',
      },
      {
        value: 'fr',
        label: '法国',
      },
      {
        value: 'de',
        label: '德国',
      },
      {
        value: 'hu',
        label: '匈牙利',
      },
    ],
    producttype: [
      {
        value: '',
        label: '请选择类型',
      },
      {
        value: '照明电工',
        label: '照明电工',
      },
      {
        value: '宠物',
        label: '宠物',
      },
      {
        value: '小家电',
        label: '小家电',
      },
      {
        value: '3C',
        label: '3C',
      },
      {
        value: '智能网片',
        label: '智能网片',
      },
    ],
    neworold: [
      {
        value: '',
        label: '请选择新旧品',
      },
      {
        value: '新品',
        label: '新品',
      },
      {
        value: '旧品',
        label: '旧品',
      },
    ],
    regionlist: [],
    PositionModuleCode: 'OAS.PositionManageMenu',
    PositionPermissonList: {
      Add: { key: 'OAS.PositionManageMenu.Add', value: false },
      Delete: { key: 'OAS.PositionManageMenu.Delete', value: false },
      Update: { key: 'OAS.PositionManageMenu.Update', value: false },
      Search: { key: 'OAS.PositionManageMenu.Search', value: false },
    },
    RackModuleCode: 'OAS.StorageRackManageMenu',
    RackPermissonList: {
      Add: { key: 'OAS.StorageRackManageMenu.Add', value: false },
      Delete: { key: 'OAS.StorageRackManageMenu.Delete', value: false },
      Update: { key: 'OAS.StorageRackManageMenu.Update', value: false },
      Search: { key: 'OAS.StorageRackManageMenu.Search', value: false },
    },
    NewRegionModuleCode: 'OAS.AreaManageMenu',
    NewRegionPermissonList: {
      Add: { key: 'OAS.AreaManageMenu.Add', value: false },
      Delete: { key: 'OAS.AreaManageMenu.Delete', value: false },
      Update: { key: 'OAS.AreaManageMenu.Update', value: false },
      Search: { key: 'OAS.AreaManageMenu.Search', value: false },
    },
    SampleModuleCode: 'OAS.SampleManageMenu',
    SamplePermissonList: {
      Add: { key: 'OAS.SampleManageMenu.Add', value: false },
      Update: { key: 'OAS.SampleManageMenu.Update', value: false },
      Search: { key: 'OAS.SampleManageMenu.Search', value: false },
      InOutSearch: { key: 'OAS.SampleManageMenu.InOutSearch', value: false },
      BatchAdd: { key: 'OAS.SampleManageMenu.BatchAdd', value: false },
      Export: { key: 'OAS.SampleManageMenu.Export', value: false },
      UpLoad: { key: 'OAS.SampleManageMenu.UpLoad', value: false },
      UpLoadStock: { key: 'OAS.SampleManageMenu.UpLoadStock', value: false },
      PutInStorage: { key: 'OAS.SampleManageMenu.PutInStorage', value: false },
      ChangeLog: { key: 'OAS.SampleManageMenu.ChangeLog', value: false },
      DownLoadSampleTemplate: {
        key: 'OAS.SampleManageMenu.DownLoadSampleTemplate',
        value: false,
      },
      QuoteSample: { key: 'OAS.SampleManageMenu.QuoteSample', value: false },
      DownLoadStockTemplate: {
        key: 'OAS.SampleManageMenu.DownLoadStockTemplate',
        value: false,
      },
      SearchCountryCode: {
        key: 'OAS.SampleManageMenu.SearchCountryCode',
        value: false,
      },
      LangDownLoadSampleTemplate: {
        key: 'OAS.SampleManageMenu.LangDownLoadSampleTemplate',
        value: false,
      },
      SearchKeyRecord: {
        key: 'OAS.SampleManageMenu.SearchKeyRecord',
        value: false,
      },
      BatchDelete: { key: 'OAS.SampleManageMenu.BatchDelete', value: false },
      BatchUpdateStorage: {
        key: 'OAS.SampleManageMenu.BatchUpdateStorage',
        value: false,
      },
      BatchSplitSubCode: {
        key: 'OAS.SampleManageMenu.BatchSplitSubCode',
        value: false,
      },
      BatchAddStorage: {
        key: 'OAS.SampleManageMenu.BatchAddStorage',
        value: false,
      },
    },
  },
  mutations: {
    increment(state) {
      state.count++;
    },
    setselectlayerid(state, layerid) {
      state.selectlayerid = layerid;
    },
    setregionlist(state, list) {
      state.regionlist = list;
    },
  },
  getters: {
    getselectlayerid(state) {
      return state.selectlayerid;
    },
    getinitstatus(state) {
      return state.initstatus;
    },
    getregionlist(state) {
      return state.regionlist;
    },
    getproducttype(state) {
      return state.producttype;
    },
    getneworold(state) {
      return state.neworold;
    },
    getdownrul(state) {
      return state.downurl;
    },
    getcountryinit(state) {
      return state.countryinit;
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/store.js